import axios from "axios";
import * as ACTION_TYPES from "./Types";
import { API_BASE, API_ADMIN } from "../../config/AppConstant";

// To login
export const login = (user) => (dispatch) => {
  return axios
    .post(`${API_BASE}${API_ADMIN}/auth/login`, { ...user })
    .then((res) => {
      if (res.data.status === 200) {
        // set access token for rest of the api
        axios.defaults.headers.common["Authorization"] =
          res.data.data.accessToken;
        dispatch({ type: ACTION_TYPES.LOGIN_SUCCESS, payload: res.data });
        return res.data;
      } else {
        dispatch({ type: ACTION_TYPES.LOGIN_ERROR, payload: res.data });
        return res.data;
      }
    })
    .catch((err) => {
      console.log(err);
      dispatch({ type: ACTION_TYPES.LOGIN_ERROR, payload: err.response });
      throw err;
    });
};

//To logout
export const logout = () => (dispatch) => {
  return axios
    .post(`${API_BASE}${API_ADMIN}/api/logout`)
    .then((res) => {
      dispatch({ type: ACTION_TYPES.LOGOUT });
      return res.data;
    })
    .catch((err) => {
      dispatch({ type: ACTION_TYPES.LOGOUT });
      throw err;
    });
};

// To change password
export const changePass = (data) => (dispatch) => {
  return axios
    .post(`${API_BASE}${API_ADMIN}/api/changePassword`, data)
    .then((res) => {
      dispatch({
        type: ACTION_TYPES.CHANGE_PASSWORD_SUCCESS,
        payload: res.data,
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: ACTION_TYPES.CHANGE_PASSWORD_ERROR,
        payload: err.response,
      });
      throw err;
    });
};

// To Forgot Password
export const forgotPass = (data) => (dispatch) => {
  return axios
    .post(`${API_BASE}${API_ADMIN}/auth/forgotPassword`, data)
    .then((res) => {
      dispatch({
        type: ACTION_TYPES.FORGOT_PASSWORD_SUCCESS,
        payload: res.data,
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: ACTION_TYPES.FORGOT_PASSWORD_SUCCESS,
        payload: err.response,
      });
      throw err;
    });
};

// To Reset Password
export const resetPass = (data) => (dispatch) => {
  return axios
    .post(`${API_BASE}${API_ADMIN}/resetPassword`, data)
    .then((res) => {
      dispatch({
        type: ACTION_TYPES.RESET_PASSWORD_SUCCESS,
        payload: res.data,
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: ACTION_TYPES.RESET_PASSWORD_SUCCESS,
        payload: err.response,
      });
      throw err;
    });
};

//To reAuthenticate if the cookie is not expired
export const authenticate = (user) => (dispatch) => {
  if (user) {
    return dispatch({ type: ACTION_TYPES.AUTHENTICATE_USER, payload: user });
  } else {
    return dispatch({ type: ACTION_TYPES.AUTHENTICATE_FAILED });
  }
};

export const loadUser = () => (dispatch) => {
  return axios
    .post(`${API_BASE}${API_ADMIN}/api/getAdminProfile`)
    .then((res) => {
      dispatch({
        type: ACTION_TYPES.LOAD_USER_SUCCESS,
        payload: res.data.data,
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({ type: ACTION_TYPES.LOAD_USER_ERROR, payload: err.response });
      throw err;
    });
};

export const editUser = (data) => (dispatch) => {
  return axios
    .post(`${API_BASE}${API_ADMIN}/api/updateAdmin`, data)
    .then((res) => {
      dispatch({ type: ACTION_TYPES.EDIT_USER_SUCCESS, payload: res.data });
      return res.data;
    })
    .catch((err) => {
      dispatch({ type: ACTION_TYPES.EDIT_USER_ERROR, payload: err.response });
      throw err;
    });
};
